import type { ComponentChildren } from "preact";
// See Design > UI, "Curator Studio assets". The render callback connects help and errors to the control.
export function Field({ id, label, hint, error, children }: {
  id: string; label: string; hint?: string; error?: string;
  children: (attributes: { id: string; "aria-describedby"?: string; "aria-invalid"?: true }) => ComponentChildren;
}) {
  const describedBy = [hint && `${id}-hint`, error && `${id}-error`].filter(Boolean).join(" ") || undefined;
  return <div class="ui-field"><label for={id}>{label}</label>
    {children({ id, ...(describedBy ? { "aria-describedby": describedBy } : {}), ...(error ? { "aria-invalid": true as const } : {}) })}
    {hint && <p id={`${id}-hint`} class="ui-field__hint">{hint}</p>}
    {error && <p id={`${id}-error`} class="ui-field__error">{error}</p>}
  </div>;
}
